import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';

interface JoinClassModalProps {
  isOpen: boolean;
  statusCode: number;
  courseId?: number;
  participantId?: number;
  onClose: () => void;
}
const JoinClassModal = ({
  isOpen,
  statusCode,
  courseId,
  participantId,
  onClose,
}: JoinClassModalProps) => {
  const { t } = useTranslation('global');
  const queryClient = useQueryClient();
  const closeModal = async (): Promise<void> => {
    await queryClient.invalidateQueries('participants');
    onClose();
  };

  const handleCreateAvatarClick = () => {
    closeModal();
  };

  return (
    <>
      {/* This modal allows a student to join a course */}
      {isOpen && (
        <div className='modal-backdrop show' style={{ backgroundColor: 'rgba(0, 0, 0, 1)' }}></div>
      )}
      <div
        className={`modal ${isOpen ? 'show' : ''}`}
        tabIndex={-1}
        role='dialog'
        style={{ display: isOpen ? 'block' : 'none' }}
        data-testid='joinClassModal'
      >
        <div className='modal-dialog' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              {statusCode == 200 ? (
                <h5 className='modal-title'>{t('joinedClass')}</h5>
              ) : (
                <h5 className='modal-title'>{t('notJoinedClass')}</h5>
              )}
              <button
                type='button'
                className='btn btn-close'
                onClick={onClose}
                aria-label='Close'
                data-testid='closeModal'
              ></button>
            </div>
            <div className='modal-body'>
              {/* Will show message based of request results */}
              {statusCode === 200 ? (
                <p>{t('joinedClassMessage')}</p>
              ) : statusCode === 404 ? (
                <p>{t('notJoinedClassError404')}</p>
              ) : statusCode === 422 ? (
                <p>{t('notJoinedClassError422')}</p>
              ) : (
                <p>{t('unexpectedError')}</p>
              )}
            </div>
            <div className='modal-footer'>
              {/* Button to allow student to configure avatar */}
              {statusCode === 200 && (
                <Link
                  to={`/courses/${courseId}/avatar/${participantId}`}
                  className='btn btn-primary'
                  onClick={handleCreateAvatarClick}
                  data-testid='createAvatar'
                >
                  {t('createAvatar')}
                </Link>
              )}

              <button type='button' className='btn btn-secondary' onClick={closeModal}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoinClassModal;
